import { Box, Stack, Typography } from '@mui/material';

export default function TagList({ items, emptyLabel = '—' }: { items: string[]; emptyLabel?: string }) {
  if (!items.length) {
    return <Typography fontSize={12}>{emptyLabel}</Typography>;
  }

  return (
    <Stack direction='row' gap={0.8} flexWrap='wrap'>
      {items.map((item) => (
        <Box key={item} sx={{ px: 1.2, py: 0.5, borderRadius: 10, bgcolor: '#F3F4F6', fontSize: 12 }}>
          {item}
        </Box>
      ))}
    </Stack>
  );
}
